export class TestingModel {
  public levelQAInResources: Array<LevelQAInResources>;

  constructor(levelQAInResources: Array<LevelQAInResources>) {
    this.levelQAInResources = levelQAInResources;
  }
}

export class Question {
  public questionText: string;

  constructor(questionText: string) {
    this.questionText = questionText;
  }
}

export class Answer {
  public answerText: string;

  constructor(answerText: string) {
    this.answerText = answerText;
  }
}

export class LevelQAInResources {
  question: Question;
  answer: Answer;

  constructor(question: Question, answer: Answer) {
    this.question = question;
    this.answer = answer;
  }
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/common/learning/models/user-testing.model.ts